import { isObject } from './isObject.js';

/**
 * Retrieves an authentication object from the authentication array by authId or authType.
 *
 * @param {Object} params - The parameters object
 * @param {Array<Object>} [params.authentication=[]] - Array of authentication objects to search through
 * @param {Object} [params.credential={}] - Credential object with authId/type in meta or secrets. Mutually exclusive with secrets.
 * @param {Object} [params.secrets={}] - Secrets object with authId and type. Mutually exclusive with credential.
 * @returns {Object|undefined} The matching authentication object if found, otherwise undefined
 */
export const getAuthByCredential = ({ authentication = [], credential = {}, secrets = {} }) => {
  const credentialAuthId = isObject(secrets) && Object.keys(secrets)?.length > 0 ? secrets?.authId : credential?.meta?.authId || credential?.secrets?.authId;
  const credentialAuthType = isObject(secrets) && Object.keys(secrets)?.length > 0 ? secrets?.type : credential?.meta?.type || credential?.secrets?.type;

  if (credentialAuthId) {
    const auth = authentication?.find((n) => n?.id === credentialAuthId);
    if (auth) {
      return auth;
    }
  }

  if (credentialAuthType) {
    const auth = authentication?.find((n) => n?.type === credentialAuthType);
    if (auth) {
      return auth;
    }
  }

  return undefined;
};

export default getAuthByCredential;
